import { render } from "./ButtonWithIcon.vue?vue&type=template&id=4f03b66e&scoped=true"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=4f03b66e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f03b66e"]])

export default __exports__